// extracted by mini-css-extract-plugin
export default {"querypage":"Count_querypage__14zp2","table":"Count_table__XoWzH"};